<template>
  <v-card>
    <v-card-title class="headline py-2">
      Редактировать признаки объекта учета
      <v-spacer></v-spacer>
      <v-btn icon class="mx-0" @click="$emit('close-dialog')">
        <v-icon>close</v-icon>
      </v-btn>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <v-layout row wrap>
        <v-flex xs12>
          <p class="subheading"><b>{{dataObject.name}}</b></p>
        </v-flex>
        <v-flex xs12 sm6>
          <p>Все признаки</p>
          <v-treeview v-model="tree" :items="objects" selected-color="primary" selectable return-object>
            <template slot="prepend" slot-scope="{ item, open, leaf }">
              <v-icon size="20" class="mx-0" :color="item.iconcolor">{{item.icon}}</v-icon>
            </template>
            <label slot="label" class="pointer" slot-scope="{item}" @click="">{{item.name}}</label>
          </v-treeview>
        </v-flex>
        <v-flex xs12 sm6>
          <p>Результат</p>
          <span>{{result}}</span>
        </v-flex>
      </v-layout>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions class="pa-3">
      <v-btn color="success" @click="submit" :disabled="status.btnDisabled">Сохранить</v-btn>
      <span :class="status.className" class="ml-2">{{status.text}}</span>
    </v-card-actions>
  </v-card>
</template>

<script>
  import {mapGetters, mapState} from 'vuex'
  import entities from '@/mixins/entities'
  
  export default {
    name : "EditObjectForm",
    
    props : {
      data : {
        type : Object,
        required : false,
        default : () => {
          return {}
        }
      },
    },
    
    created() {
      this.dataObject = JSON.parse( JSON.stringify( this.data ) )
      this.$store.dispatch('app/org/tree', 'other').then(usersTree => {
        this.treedata = usersTree
        this.$nextTick(function(){
          this.dataObject.properties.map(item => {
            let id = (item.element_type==='property') ? item.property_id : item.identified
            this.tree.push({id})
          })
        })
      })
      
    },
    
    computed:{
      ...mapGetters('app/org', ['getPostById','getContainerById']),
      ...mapState(`analytics/constructor`, ['propertiesTree']),
      objects(){
        return this.propertiesTree.concat([
          { id: 'org', name: 'Оргструктура', children: this.treedata}
        ])
      }
    },
    
    data() {
      return {
        status : {
          btnDisabled : false,
          text : '',
          className : 'success--text darken-1'
        },
        dataObject : {},
        tree: [],
        treedata: [],
        result: '',
        new_properties: []
      }
    },
    
    methods : {
      
      submit() {
        this.status = { btnDisabled : true, text : 'Сохранение', className : 'secondary--text lighten-1' }
        
        let data = {
          old: this.data.properties,
          new: this.new_properties,
          join_type: 2
        }
        this.$store.dispatch( 'analytics/constructor/changeObjectProps', data ).then( response => {
          this.status = { btnDisabled : false, text : 'Сохранено', className : 'success--text darken-1' }
          this.$emit('save', {type: 'editObject', data: this.data, properties: this.new_properties, propsname: this.result})
        }).catch( error => {
          this.status = { btnDisabled : false, text : 'Ошибка', className : 'error--text darken-1' }
        })
      }
    },
  
    watch:{
      tree(val){
        let tree = val.filter( item => (item.element_type && item.element_type!=='folder'))
        let name = ''
        this.new_properties = []
        tree.map( (item, index) => {
          if(item.element_type && tree.findIndex(el=>el.id===item.parent_id)<0){
            if(item.element_type==='property'){
              this.new_properties.push({
                element_type: item.element_type,
                identified: item.name,
                property_id: item.id,
              })
            } else {
              this.new_properties.push({
                element_type: item.element_type,
                identified: item.id,
              })
            }
            name = name+item.name+' -> '
          }
        })
        this.result = name.slice(0, -3)
      }
    }
    
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/apps/analytics/components/Constructor/Forms/EditObjectForm.vue